import React from 'react';

const DefaultPage = () => {
    return (
        <div>
            <h1>Default Page</h1>
            <p>Welcome to the default page!</p>
        </div>
    );
};

export default DefaultPage;